export default "__VITE_ASSET__BJn5rayo__"